import { shortenedCountNumber } from 'helpers/string';

export const calculateBadgeLabel = (notificationsChatsCount: number): string => {
  if (notificationsChatsCount > 0) {
    return shortenedCountNumber(notificationsChatsCount);
  }

  return '';
};
